import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs/operators';

// Service
import { AuthService } from '../auth/auth.service';
import { UserSessionService } from '../user/user.service';

/**
 * Guard to force the user to choose an app
 */
export const loginGuard: CanActivateFn = (route, state) => {
  const userSessionService = inject(UserSessionService);
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!userSessionService.isLogin()) {
    router.navigate(['/sign-in'], {
      queryParams: { redirectUrl: state.url },
    });
    return false;
  }

  const authentication = localStorage.getItem('new_user_login') || '';
  if (authentication === 'true') {
    const userId = localStorage.getItem('userId');
    const userToken = localStorage.getItem('token');
    if (!userId || !userToken) {
      authService.logout();
      return false;
    }
    return authService.verifyToken(userId, userToken).pipe(
      map((isTokenValid) => {
        if (!isTokenValid) authService.logout();
        return isTokenValid;
      }),
    );
  }

  authService.logout();
  return false;
};
